import { Container } from '@tribeplatform/react-ui-kit/Layout'

import { ApiUsagesSection } from './ApiUsages/ApiUsagesSection.js'
import { ResourceUsagesSection } from './ResourceUsages/ResourceUsagesSection.js'

export const UsagesPage = () => {
  return (
    <Container size="lg" spacing="xl">
      <ResourceUsagesSection />
      <ApiUsagesSection />
    </Container>
  )
}
